<div
  [ngClass]="{
    'order-entry__panel-more__partial-fill__container': true,
    'order-entry__panel-more__partial-fill__container--checked': data.checkbox.value && !data.locked,
    'order-entry__panel-more__partial-fill__container--unchecked': !data.checkbox.value && !data.locked,
    'order-entry__panel-more__partial-fill__container--locked': data.locked}"
>
  <p-checkbox
    class="order-entry__panel-more__partial-fill bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
    [label]="data.label"
    [binary]="true"
    [disabled]=" data.locked"
    [(ngModel)]="data.checkbox.value"
  >
  </p-checkbox>
</div>
